//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  data() {
    return {
      //表格部分
      tableData: [
        {
          goodsImg: "../../../assets/empty.png",
          goodsName: "皮蛋瘦肉粥",
          goodsPrice: "10",
          price: "8.00",
          goodsAttribute: "含金量500ml 毒性:五毒",
          goodsNum: "10",
          // goodsNum: "20",
          totalPay: "8",
        },
      ],
      orderId: "",
    };
  },
  mounted() {
    this.orderId = this.$route.query.orderId;
  },
  created() {
    this.tableData = JSON.parse(sessionStorage.getItem("infoGoods"));
  },
  methods: {
    // 取消
    cancelProduct() {
      this.$router.go(-1);
    },
    // 修改商品提交
    submitProduct() {
      this.$http.szOrder
        .editGoods({
          orderId: this.orderId,
          goodsNum: this.tableData[0].goodsNum,
          price: this.tableData[0].price,
        })
        .then((res) => {
          if (res.status == 1) {
            this.stepLoading = false;
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.$router.go(-1);
            setTimeout(() => {
              this.stepLoading = false;
            }, 1000);
          }
        });
    },
  },
};
